import { createDefault } from "../../utils/ConstUtils";

export default createDefault([{ value: 3, text: "実績調整", enum: "C" }]);
